import { lighten, makeStyles } from "@material-ui/core/styles";

export const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  flex: {
    display: "flex",
    alignItems: "center",
    flex: "1 1 100%",
  },
  title: {
    marginRight: 16,
  }
  
}));

export const useHeadStyles = makeStyles((theme) => ({  
  transparentHead: {
    "& .MuiTableCell-head": {
      backgroundColor: "#fff"
    },
  }
}));
